import React from 'react';
import {TerminalScreen} from 'src/v2/components/screen/TerminalScreen';
import {defineMessages, useIntl} from 'react-intl';
import {BrandedButton} from 'src/v2/components/common/BrandedButton';
import {view} from '@sail/ui';
import {safeWindowOpen} from '@stripe-internal/safe-links';

const messages = defineMessages({
  title: {
    id: 'crypto.payins.v2.errored_screen.title',
    description: 'Title for screen when payment has errored',
    defaultMessage: 'There was a problem with your payment',
  },
  subtitle: {
    id: 'crypto.payins.v2.errored_screen.subtitle',
    description: 'Subtitle for screen when payment has errored',
    defaultMessage:
      "We couldn't process your payment. Please contact support for help.",
  },
  contactSupport: {
    id: 'crypto.payins.v2.errored_screen.contact_support',
    description: 'Button text to contact support',
    defaultMessage: 'Contact support',
  },
});

export const ErroredScreen = () => {
  const intl = useIntl();

  const handleContactSupport = () => {
    safeWindowOpen(
      'https://support.stripe.com/user/topics/stablecoin-and-crypto-payments',
      '_blank',
    );
  };

  return (
    <TerminalScreen
      title={intl.formatMessage(messages.title)}
      subtitleMessage={intl.formatMessage(messages.subtitle)}
      isSuccess={false}
    >
      <view.div css={{display: 'flex', justifyContent: 'center'}}>
        <BrandedButton onClick={handleContactSupport}>
          {intl.formatMessage(messages.contactSupport)}
        </BrandedButton>
      </view.div>
    </TerminalScreen>
  );
};
